import { render, staticRenderFns } from "./Text_Error.vue?vue&type=template&id=8e07e2e4&scoped=true&"
import script from "./Text_Error.vue?vue&type=script&lang=js&"
export * from "./Text_Error.vue?vue&type=script&lang=js&"
import style0 from "./Text_Error.vue?vue&type=style&index=0&id=8e07e2e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e07e2e4",
  null
  
)

export default component.exports